import React from "react";
import { capitalizeFirst } from "../../util/YearOptions";

// Merged Employee Name + Code cell — same design as Employee Directory (EmployeeMasterList).
const EmpNameCodeCell = ({ name, code }) => (
  <div
    className="emp-name-code-cell"
    style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", width: "100%", textAlign: "left" }}
  >
    <span style={{ textTransform: "capitalize", fontWeight: 600 }}>{capitalizeFirst(name)}</span>
    {code && (
      <span className="emp-name-code-cell__code" style={{ color: "#8c8c8c", fontSize: 12, lineHeight: "16px" }}>
        {code}
      </span>
    )}
  </div>
);

export default EmpNameCodeCell;
